import './CheckoutPage.css'; 
import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient'; // Adjust the import path as necessary

const CheckoutPage = () => {
  // Placeholder data
  const orderItems = [
    { id: 1, description: 'Html theme', quantity: 3, amount: 60.0 },
    { id: 2, description: 'Bootstrap snippet', quantity: 1, amount: 20.0 },
    { id: 3, description: 'Snippets on bootdey', quantity: 2, amount: 18.0 },
  ];

  const subtotal = orderItems.reduce((total, item) => total + item.amount, 0);
  const shippingCost = 0;
  const discountRate = 4.5;
  const discount = (subtotal * discountRate) / 100;
  const total = subtotal - discount + shippingCost;

  return (
    <div className="checkout-container">
      <div className="product-section">
        <img src="gift.png" alt="Example Product" />
        <h2>Example Product</h2>
        <p>$25.00</p>
        <button>Checkout via Gift Card</button>
      </div>
      <div className="order-summary">
        <div className="payment-info">
          <p>Payment No. 434334343</p>
          <p>Payment Date: Jul 09, 2014 - 12:20 pm</p>
        </div>
        <table>
          <tbody>
            {orderItems.map((item) => (
              <tr key={item.id}>
                <td>{item.description}</td>
                <td>{item.quantity}</td>
                <td>${item.amount.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="totals">
          <p>Subtotal: ${subtotal.toFixed(2)}</p>
          <p>Shipping: ${shippingCost.toFixed(2)}</p>
          <p>Discount: {discountRate}%</p>
          <p>Total: ${total.toFixed(2)}</p>
        </div>
      </div>
      <div className="notes">
        <p>Notes</p>
        {/* Additional checkout information here */}
      </div>
    </div>
  );
};

export default CheckoutPage;
